<template>
  <div class="login-page">
    <div class="login-card">
      <div class="login-header">
        <h1>后台管理</h1>
        <p>请登录以继续</p>
      </div>
      <div class="login-form">
        <div class="field">
          <label>用户名</label>
          <input v-model="username" type="text" placeholder="请输入用户名" @keyup.enter="focusPwd" />
        </div>
        <div class="field">
          <label>密码</label>
          <input ref="pwdInput" v-model="password" type="password" placeholder="请输入密码" @keyup.enter="login" />
        </div>
        <div class="error" v-if="errMsg">{{ errMsg }}</div>
        <button class="login-btn" @click="login" :disabled="loading">
          {{ loading ? '登录中...' : '登 录' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '@/utils/api';

export default {
  name: 'AdminLogin',
  data() {
    return {
      username: '',
      password: '',
      errMsg: '',
      loading: false
    };
  },
  methods: {
    focusPwd() {
      this.$refs.pwdInput.focus();
    },
    async login() {
      this.errMsg = '';
      if (!this.username.trim() || !this.password.trim()) {
        this.errMsg = '请输入用户名和密码';
        return;
      }
      this.loading = true;
      try {
        const data = await api.post('/api/admin/login', {
          username: this.username.trim(),
          password: this.password
        });
        if (data.code === 200) {
          sessionStorage.setItem('adminToken', data.data.token);
          this.$router.replace('/admin/dashboard');
        } else {
          this.errMsg = data.message || '登录失败';
        }
      } catch {
        this.errMsg = '网络错误，请稍后重试';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #e8f5e9, #f5f5f5);
  padding: 20px;
}
.login-card {
  width: 380px;
  max-width: 100%;
  background: #fff;
  border-radius: 16px;
  padding: 40px 30px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.08);
  border-top: 4px solid #27ae60;
}
.login-header {
  text-align: center;
  margin-bottom: 30px;
}
.login-header h1 {
  font-size: 24px;
  color: #1a1a1a;
  margin: 0 0 6px;
  letter-spacing: 2px;
}
.login-header p {
  font-size: 14px;
  color: #999;
  margin: 0;
}
.field {
  margin-bottom: 18px;
}
.field label {
  display: block;
  font-size: 14px;
  color: #333;
  margin-bottom: 6px;
  font-weight: 500;
}
.field input {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 15px;
  outline: none;
  transition: border 0.2s;
  box-sizing: border-box;
}
.field input:focus {
  border-color: #27ae60;
}
.error {
  color: #e74c3c;
  font-size: 13px;
  margin-bottom: 12px;
  text-align: center;
}
.login-btn {
  width: 100%;
  padding: 13px;
  background: linear-gradient(135deg, #2ecc71, #27ae60);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  letter-spacing: 2px;
  transition: all 0.2s;
}
.login-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(39,174,96,0.3);
}
.login-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
